import * as React from "react";
const SvgFiRrClockDesk = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="#062147"
      d="M8.168 12.555a1 1 0 0 1 .277-1.387L11 9.465V6a1 1 0 1 1 2 0v4c0 .334-.167.646-.445.832l-3 2a.998.998 0 0 1-1.387-.277M22 10v9c0 2.757-2.243 5-5 5H7c-2.757 0-5-2.243-5-5v-9c0-.079.027-.73.027-.73C2.402 4.096 6.732 0 12 0s9.598 4.096 9.973 9.27c.017.074.027.651.027.73M4 10c0 4.411 3.589 8 8 8s8-3.589 8-8-3.589-8-8-8-8 3.589-8 8m16 5.993A10 10 0 0 1 12 20a10 10 0 0 1-8-4.007V19c0 1.654 1.346 3 3 3h10c1.654 0 3-1.346 3-3z"
    />
  </svg>
);
export default SvgFiRrClockDesk;
